import { createListenerMiddleware } from "@reduxjs/toolkit";
import { setLogout } from "features/authSlice";
import { setNativeAppBannerDismissed } from "features/nativeAppPromoSlice";
import { setIsLanguageToggleLocked } from "features/preferredLanguageSlice";
import { afterLogoutApi } from "pages/login/afterLogoutService";
import { clearLoanOfficerDetail } from "services/common/loanOfficerSlice";
import { clearPreferredLanguageStorageOnLogout } from "utilities/getPreferredLanguage";
import { clearNativeAppPromoSessionStorage } from "./clearNativeAppPromoSessionStorage";

export const listenerMiddleware = createListenerMiddleware();

listenerMiddleware.startListening({
  actionCreator: setLogout,
  effect: async (_, listenerApi) => {
    listenerApi.dispatch(clearLoanOfficerDetail());
    listenerApi.dispatch(setIsLanguageToggleLocked(false));
    listenerApi.dispatch(setNativeAppBannerDismissed(false));

    clearNativeAppPromoSessionStorage();
    clearPreferredLanguageStorageOnLogout();
    try {
      await listenerApi.dispatch(afterLogoutApi.endpoints.postAfterLogout.initiate());
    } catch (err) {
      console.error("Failed to call after-logout endpoint", err);
    }
  },
});
